const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.4595 26.5683C22.6601 25.8568 26.6668 21.3966 26.6668 16.0007C26.6668 10.1096 21.8912 5.33398 16.0002 5.33398C10.1091 5.33398 5.3335 10.1096 5.3335 16.0007C5.3335 21.3453 9.2643 25.7718 14.3926 26.547V19.0602H11.8263V16.0895H14.3926V13.8994C14.3926 11.3571 15.9461 9.97177 18.2162 9.97177C18.9811 9.96902 19.7456 10.0078 20.5063 10.0879V12.7463H18.9329C17.6997 12.7463 17.4595 13.3309 17.4595 14.1917V16.0895H20.4022L20.0219 19.0602H17.4595V26.5683ZM16.0283 26.6673H15.9721C15.9814 26.6673 15.9908 26.6673 16.0002 26.6673C16.0095 26.6673 16.0189 26.6673 16.0283 26.6673Z",
  fill: "white"
});
function SvgFacebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a3b6b19cb9d4cea6ba82aa686a4fe8e4.svg";
export { ForwardRef as ReactComponent };